let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kDPsc"), load("6CK1s")]).then(() => parcelRequire('a43ur'));